<template>
  <div class="Appointment">
    <div class="top">
      <p>
        <span>患者姓名/手机号码:</span>
        <Input v-model="searchName" placeholder="患者姓名/手机号码" style="width:200px"/>
      </p>
      <p>
        <span>医生姓名:</span>
        <Input v-model="doctorName" placeholder="医生姓名" style="width:200px"/>
      </p>
      <p>
        <span>状态:</span>
        <Select v-model="searchState" style="width:200px">
          <Option v-for="item in searchStateList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </p>
      <Button type="primary" custom-icon="iconfont icon-sousuo1" class="basicBtn" @click="search" @keyup.enter.native="search()">搜索</Button>
      <Button type="primary" custom-icon="iconfont icon-jia" class="basicBtn" @click="newApRe">新增预约挂号</Button>
      <!-- <Button type="primary" custom-icon="iconfont icon-daoru" class="basicBtn">导入</Button>
      <Button type="primary" custom-icon="iconfont icon-xiazai" class="basicBtn">下载模板</Button> -->
    </div>
    <div class="main">
      <div class="leftBox">
        <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1" @on-select="selectOneApReg"></Table>
        <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize"/>
        </div>
      </div>
      <div class="rightBox"  ref="rightBox" v-bind:style="rightBox">
        <ul>
          <li>
            <label>姓名:</label>
            <Input v-model="patientName" placeholder="姓名" style="width:160px" :disabled="isDisabled"/>
          </li>
          <li>
            <label>手机号:</label>
            <Input v-model="phone" placeholder="手机号" style="width:160px" :maxlength="11" :disabled="isDisabled"/>
          </li>
          <li>
            <label>性别:</label>
            <RadioGroup v-model="gender"  @on-change="selectGender">
              <Radio :label="item.value" v-for="(item,index) in genderList" :key="index" :disabled="isDisabled">{{item.label}}</Radio>
            </RadioGroup>
          </li>
          <li class="ageBox">
            <label>年龄:</label>
            <div>
              <Input v-model="age" placeholder="年龄" style="width:100px" :disabled="isDisabled"/>
              <Select v-model="ageUnit" style="width:80px" :disabled="isDisabled">
                <Option v-for="item in ageUnitList" :value="item.value" :key="item.value" >{{ item.label }}</Option>
              </Select>
            </div>
          </li>
          <li>
            <label>科室:</label>
            <Select v-model="department" style="width:160px" @on-change="departChange" :disabled="isDisabled">
              <Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </li>
          <li>
            <label>医生:</label>
            <Select v-model="doctor" style="width:160px" :disabled="isDisabled">
              <Option v-for="item in doctorList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </li>
          <li>
            <label>来源:</label>
            <Select v-model="origin" style="width:160px" :disabled="isDisabled">
              <Option v-for="item in originList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </li>
          <li>
            <label>类型:</label>
            <RadioGroup v-model="genre" @on-change="selectGenre">
              <Radio :label="ge.value" v-for="(ge,index) in genreList" :key="index" :disabled="isDisabled" >{{ge.label}}</Radio>
            </RadioGroup>
          </li>
          <li v-show="!isAppoint">
            <label>预约时间:</label>
            <div v-show="isSelTime">
              <DatePicker v-model="appointDate" type="date" format="yyyy-MM-dd" @on-change="time1"  placeholder="日期" style="width: 105px" :disabled="isDisabled"></DatePicker>
              <Select v-model="hour" style="width:50px">
                <Option v-for="item in hourList" :value="item.value" :key="item.value" :disabled="isDisabled">{{ item.label }}</Option>
              </Select>
              <Select v-model="minute" style="width:50px" >
                <Option v-for="item in minuteList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            <div v-show="!isSelTime">
              <p>{{appTime}}</p>
            </div>
          </li>
          <li v-show="isNewAppeg">
            <label>状态:</label>
            <Select v-model="state" style="width:80px">
              <Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </li>
          <li>
            <Button v-show="isAppoint" size="small" custom-icon="iconfont icon-666" class="basicBtn" @click="appointReg">挂号</Button>
            <Button v-show="isConfirmApp" size="small" custom-icon="iconfont icon-666" class="basicBtn" @click="confirmAppoint">确认预约</Button>
            <Button v-show="isSave" size="small" custom-icon="iconfont icon-baocun" class="basicBtn" @click="saveAppReg">保存</Button>
            <Button v-show="isConfirmReg" size="small" custom-icon="iconfont icon-666" class="basicBtn" @click="ConfirmRegi">确认挂号</Button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  forClinicList,clinicDoctor,
  appointRegister,saveAppoiReg,
  clinicSelList,updAppoiReg
} from "../../api/appoint";
import {
  patientSource,patientByname
} from "../../api/clinic";
import { tips,replaceT,payType,appRegState,patiSourFilter,formatDate } from "../../tools";
export default {
  name: 'Appointment',
  inject: ['reload'],
  data () {
    return {
      tableHeight:632,
      rightBox:{
        // minHeight:'500px',
        height:'450px',
      },
      isDisabled:false,
      diagnosisState:'',//预约挂号状态
      appTime:'',//保存时间
      total:0,
      pageCurrent:1,
      pageSize: 10,
      isNewAppeg:false,//是否为新建预约或者挂号
      isAppoint:true,//挂号收费
      isSelTime:true,//是否显示日期选择
      isSave:false,//保存按钮
      isConfirmApp:false,//确认预约
      isConfirmReg:false,//确认挂号
      searchName:'',//患者姓名/手机号
      doctorName:'',//医生姓名
      state:'',
      stateList:[
        {
          label:'待诊',
          value:1
        },
        {
          label:'已诊',
          value:3
        }
      ],
      searchState:'',
      searchStateList:[
        {
          label:'待诊',
          value:1
        },
        {
          label:'接诊中',
          value:2
        },
        {
          label:'已诊',
          value:3
        },
        {
          label:'预约',
          value:4
        },
        {
          label:'已过期',
          value:5
        },
        {
          label:'已过号',
          value:6
        }
      ],
      columns1:[
        {
          title: '选中',
          align:'center',
          key: 'checkBox',
          render:(h,params)=>{
              return h('div',[
                  h('Checkbox',{
                      props:{
                          value:params.row.checkBox
                      },
                      on:{
                          'on-change':(e)=>{
                              console.log(e)
                              if(e==true){
                                this.isDisabled = true;
                              }else{
                                this.isDisabled = false;
                              }
                              this.data1.forEach((items)=>{      //先取消所有对象的勾选，checkBox设置为false
                                  this.$set(items,'checkBox',false)
                              });
                              this.data1[params.index].checkBox = e;  //再将勾选的对象的checkBox设置为true
                              this.selectOneApReg(params.row);
                          }
                      }
                  })
              ])
          }
        },
        {
          title: '状态',
          key: 'diagnosisState',
          align:'center',
          sortable: true,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: appRegState(''+params.row.diagnosisState) 
              },
            })
          }
        },
        {
          title: '姓名',
          key: 'hospitalPatientName',
          align:'center',
        },
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
          title: '年龄',
          key: 'age',
          align:'center'
        },
        {
          title: '年龄单位',
          key: 'ageUnit',
          align:'center',
          width:58
        },
        {
          title: '手机号',
          key: 'mobile',
          align:'center',
          width:85
        },
        {
          title: '科室',
          key: 'departmentName',
          align:'center'
        },
        {
          title: '医生',
          key: 'doctorName',
          align:'center',
          sortable: true
        },
        // {   
        //   title: '来源',
        //   key: 'sourceType',
        //   align:'center',
        //   render:(h,params) => {
        //     return h('div',{
        //       style: {
        //         textAlign: 'center',
        //       },
        //       domProps: {
        //         innerHTML: patiSourFilter(params.row.sourceType) 
        //       },
        //     })
        //   }
        // },
        {
          title:'来源',
          key:'sourceName',
          align:'center'
        },
        {
          title: '操作员',
          key: 'doctorName',
          align:'center',
          sortable: true
        },
        {
          width:140,
          title:'挂号/预约时间',
          key: 'registeredTime',
          align:'center',
          sortable: true,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.registeredTime)
              },
            })
          }
        }
      ],
      data1:[
      ],
      gender:0,
      genderList:[
        {
          label:'男',
          value:1
        },
        {
          label:'女',
          value:2
        },
        {
          label:'不详',
          value:3
        }
      ],
      patientName:'',
      phone:'',
      age:'',
      ageUnit:'岁',
      ageUnitList:[
        {
          label:'岁',
          value:'岁'
        },
        {
          label:'个月',
          value:'个月'
        },
        {
          label:'天',
          value:'天'
        }
      ],
      department:'',//科室
      departmentList:[

      ],
      doctor:'',//医生
      doctorList:[
      ],
      origin:'',//来源
      originList:[
        {
          label:'微信',
          value:'0'
        }
      ],
      genre:1,
      genreList:[
        {
          label:'挂号',
          value:1
        },
        {
          label:'预约',
          value:2
        }
      ],
      appointDate:'',
      hour:'06',
      hourList:[
        {
          label:6,
          value:'06'
        },
        {
          label:7,
          value:'07'
        },
        {
          label:8,
          value:'08'
        },
        {
          label:9,
          value:'09'
        },
        {
          label:10,
          value:'10'
        },
        {
          label:11,
          value:'11'
        },
        {
          label:12,
          value:'12'
        },
        {
          label:13,
          value:'13'
        },
        {
          label:14,
          value:'14'
        },
        {
          label:15,
          value:'15'
        },
        {
          label:16,
          value:'16'
        },
        {
          label:17,
          value:'17'
        },
        {
          label:18,
          value:'18'
        },
        {
          label:19,
          value:'19'
        },
        {
          label:20,
          value:'20'
        },
        {
          label:21,
          value:'21'
        }
      ],
      minute:'00',
      minuteList:[
        {
          label:'00',
          value:'00'
        },
        {
          label:'15',
          value:'15'
        },
        {
          label:'30',
          value:'30'
        },
        {
          label:'45',
          value:'45'
        }
      ],
      receivable:'0.00',//应收
      discount:'',//优惠
      received:'',//实收
      overtimer:null
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    // console.log(this.$refs.table.$el);l
    this.$nextTick(() => {
      window.addEventListener('resize', this.getTableHeight);
      this.getTableHeight();

      this.getClinic();  
      this.patientSource();
      this.loadList();
    })


  },
  methods:{
    getTableHeight(){
      // console.log(this.$refs.table);
      // 设置表格高度 
      if(this.$refs){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-80; 
        // console.log(this.tableHeight);
        // console.log(this.$refs.rightBox.offsetTop);
        
        this.$forceUpdate();
        this.$set(this.rightBox,'height',(window.innerHeight-this.$refs.rightBox.offsetTop-20)+'px');
        // console.log(this.rightBox.height);
      }
    },
    //加载页面数据
    loadList(){
      let myDate = new Date();
      // console.log(formatDate(myDate,'01','01'));
      this.appointDate = formatDate(myDate,'01','01');
      console.log(this.appointDate)
      this.search();
    },
    //查询预约挂号
    search(){
      
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        doctorName: _this.doctorName,
        name: _this.searchName,
        size: _this.pageSize,
        state: _this.searchState
      };
      appointRegister(
        params
      ).then(res => {
        console.log(res);
        let data = res.records;
        _this.data1 = data;
        _this.total = res.total;

        _this.age = '';
        _this.ageUnit = '岁';
        // _this.department = '';
        _this.doctor = '';
        _this.patientName = '';
        _this.phone = '';
        _this.gender = 0;
        _this.origin = 0;
        _this.genre = 1;
      });
    },
    time1(e){
      this.appointDate = e;
      console.log(e);
    },
    //预约挂号保存
    saveAppReg(){
      let _this = this;
      //type变成挂号，state变成待诊
      let params = {
        state:_this.state,
        id:_this.editId
      };
      updAppoiReg(
        params
      ).then(res => {
        console.log(res);
        tips(this,res.data,'success');
        // this.reload();
        this.$router.push({path:'/cliniclist'});
      });
    },
    //挂号收费
    appointReg(){
      let _this = this;
      let params = {
        address: _this.address,
        age: _this.age,
        ageUnit: _this.ageUnit,
        departmentId: _this.department,
        doctorId: _this.doctor,
        hospitalPatientName: _this.patientName,
        mobile: _this.phone,
        sex: _this.gender,
        sourceType: _this.origin,
        type: _this.genre
      };
      console.log(params.mobile.length);
      
      if(params.hospitalPatientName==''){
        tips(this,'请填写患者名称！','info');
      }else if(params.mobile==''){
        tips(this,'请填写手机号！','info');
      }else if(params.sex==''){
        tips(this,'请选择性别！','info');
      }else if(params.age==''){
        tips(this,'请填写年龄！','info');
      }else if(params.departmentId==''){
        tips(this,'请选择科室','info');
      }else if(params.doctorId==''){
        tips(this,'请选择医生','info');
      }
      else{
        _this.getAppReg(params);
      }
    },
    //确认预约
    confirmAppoint(){
      let _this = this;
      // console.log( _this.appointDate)
      _this.appTime = formatDate(_this.appointDate,'01','01')+' '+_this.hour+':'+_this.minute;
      console.log(_this.appTime)
      let params = {
        address: _this.address,
        age: _this.age,
        ageUnit: _this.ageUnit,
        departmentId: _this.department,
        doctorId: _this.doctor,
        hospitalPatientName: _this.patientName,
        mobile: _this.phone,
        sex: _this.gender,
        sourceType: _this.origin,
        time: _this.appTime,
        type: _this.genre
      };
      if(params.hospitalPatientName==''){
        tips(this,'请填写患者名称！','info');
      }else if(params.mobile==''){
        tips(this,'请填写手机号！','info');
      }else if(params.mobile.length!=11){
        tips(this,'请填写正确的手机号','info');
      }else if(params.sex==''){
        tips(this,'请选择性别！','info');
      }else if(params.age==''){
        tips(this,'请填写年龄！','info');
      }else if(params.departmentId==''){
        tips(this,'请选择科室','info');
      }else if(params.doctorId==''){
        tips(this,'请选择医生','info');
      }
      else{
        _this.getAppReg(params);
      }
    },
    //确认挂号
    ConfirmRegi(){
      let _this = this;
      //type变成挂号，state变成待诊
      let params = {
        state:1,
        type: 2,
        id:_this.editId
      };
      updAppoiReg(
        params
      ).then(res => {
        console.log(res);
        tips(this,res.data,'success');
        this.reload();
      });
    },
    //预约挂号数据
    getAppReg(params){
      let _this = this;
      saveAppoiReg(
        params
      ).then(res => {
        console.log(res);
        if(res){
          tips(this,res.data.msg,'success');
          if(params.type==1){
            let menus = _this.$store.state.menus;
            let idx = menus.findIndex(item=>item.url=='/cliniclist');
            console.log(menus)
            console.log(idx);
            if(idx!=-1){
              console.log(menus[idx].id);
              _this.$store.commit('setCheckMenu',menus[idx].id);
              _this.$store.commit('setTags',menus[idx].id);
              _this.$router.push({path:'/cliniclist',query:{appId:res.data.hospitalPatientId}});
            }
          }else{
            this.reload();
          }
        }
      });
    },
    //科室下拉
    getClinic(){
      let _this = this;
      clinicSelList({}).then(res => {
        console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj={
            value:0,
            label:''
          }
          // obj.value = item.departmentCode;
          obj.value = item.id;
          obj.label = item.departmentName;
          arr.push(obj);
          // console.log(arr);
        });
        _this.departmentList = arr;
        console.log(_this.departmentList);
        _this.department = _this.departmentList[0].value;
        console.log(_this.department);
        _this.getClinicDoctor(_this.department);
      });
    },
    //选择科室
    departChange(val){
      console.log(val);
      //存在返回值说明有选项
      if(val){
        this.getClinicDoctor(val);
      }
    },
    //医生下拉
    getClinicDoctor(id){
      let _this = this;
      clinicDoctor({
        id:id
      }).then(res=>{
        // console.log(res);
        //存在数据
        if(res){
          let data = res.data.data;
          console.log(data);
          let arr = [];
          data.forEach(item => {
            let obj={
              value:0,
              label:''
            }
            // obj.value = item.departmentCode;
            obj.value = item.id;
            obj.label = item.name;
            arr.push(obj);
          });
          _this.doctorList = arr;
          _this.doctor = _this.doctorList[0].value;
          console.log(_this.doctorList);
        }else{
          _this.doctorList = [];
        }
      });
    },
    //患者来源
    patientSource(){
      let _this = this;
      patientSource({})
      .then(res => {
        console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj={
            value:'',
            label:''
          }
          // obj.value = item.departmentCode;
          obj.value = item.dataCode;
          obj.label = item.dataName;
          arr.push(obj);
        });
        _this.originList = arr;
        // _this.origin = _this.originList[0].value;
      });
    },
    
    //
    selectGender(val){
      console.log(val);
    },
    //挂号预约类型,显示隐藏相关部分
    selectGenre(val){
      // console.log(val);
      switch(val){
        case 1:
          this.isAppoint = true;
          this.isConfirmApp = false;
          break;
        case 2:
          this.isAppoint = false;
          this.isConfirmApp = true;
          break;
      }
    },
    //选中一项,右边出现数据
    selectOneApReg(row){
      let _this = this;
      _this.isDisabled = true;
      // console.log(selection);
      console.log(row);
      _this.age = row.age;
      _this.ageUnit = row.ageUnit;
      _this.department = row.departmentId;
      _this.getClinicDoctor(_this.department);
      _this.doctor = row.doctorId;
      _this.patientName = row.hospitalPatientName;
      _this.phone = row.mobile;
      _this.gender = row.sex;
      _this.origin = row.sourceType;
      _this.genre = row.type;
      _this.appTime = replaceT(row.registeredTime);
      _this.editId = row.id;
      console.log(_this.editId);
      _this.selectGenre(_this.genre);
      //挂号预约状态
      _this.diagnosisState = row.diagnosisState;
      console.log(row.diagnosisState);
      switch(row.diagnosisState){
        case 1:
        case 3:
        case 5:
        case 6:
          _this.isAppoint = false;
          _this.isSave = false;
          _this.isConfirmApp = false;
          _this.isConfirmReg = false;
          _this.isNewAppeg = false;
          _this.isSelTime = false;
          break;
        case 2:
          break;
          _this.isAppoint = false;
          _this.isSave = true;
          _this.isConfirmApp = false;
          _this.isConfirmReg = false;
          _this.isNewAppeg = true;
          _this.isSelTime = false;
        case 4:
          _this.isAppoint = false;
          _this.isSave = false;
          _this.isConfirmApp = false;
          _this.isConfirmReg = true;
          _this.isNewAppeg = false;
          _this.isSelTime = false;
          break;
        
      }
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    //新建预约挂号
    newApRe(){
      this.reload();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.Appointment{
  border: 1px solid #c9c9c9;
  overflow: scroll;
  height: 100%;
}
.top{
  padding: 20px;
  border-bottom: 1px solid #c9c9c9;
  display: flex;
  justify-content:baseline;
  flex-flow: wrap row;
}
.top>p:not(:last-child){
  display: flex;
  justify-content: space-between;
  flex-flow: wrap row;
  margin-bottom: 10px;
}
.top>p>span{
  display: inline-block;
  height: 36px;
  line-height: 36px;
  color: #030303;
  font-size: 16px;
  margin-right: 10px;
}
.top>p{
  margin-right: 20px;
}
.top>p>.ivu-input-wrapper{
  height: 36px;
}
.top>p /deep/ .ivu-select-selection{
  height: 36px;
}
.top>p /deep/ input{
  height: 36px;
}
.top>.ivu-btn{
  margin-right:20px;
}
.main{
  padding: 20px;
  /* height: 28px; */
}
.main{
  /* padding: 18px 53px 0 52px; */
  display: flex;
  justify-content: space-around;
}
.leftBox{
  width: 75%;
  display: inline-block;
}
.rightBox{
  /* min-height:300px; */
  max-height: 80%;
  overflow-y: scroll;
  width: 25%;
  border: 1px solid #c9c9c9;
  padding: 15px 5px;
  display: inline-block;
  background-color: #fff;
  margin-left: 20px;
}
.rightBox>ul{
  overflow-y: scroll;
  height: 100%;
}
.rightBox>ul>li{
  display: flex;
  justify-content: flex-start;
  flex-flow: nowrap row;
  /* height: 36px; */
  line-height: 42px;
}
.rightBox>ul>li>div.ivu-input-wrapper,.rightBox>ul>li>div.ivu-select{
  padding-top: 5px;
}
.rightBox>ul>li:last-child{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.rightBox>ul>li:last-child>button{
  margin-right: 20px;
  width: 90px;
}
.rightBox>ul>li>label{
  min-width: 80px;
  width: 30%;
  text-align: right;
  padding-right: 10px;
}
.rightBox>ul>li>label>div{
  width: 68%;
}
.rightBox>ul>li>div>p{
   font-size: 14px;
}
   
/* rili */
.ivu-icon{
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ivu-icon-ios-calendar-outline:before {
    content: "\e622";
}
.basicBtn{
  height: 36px;
}
.pageBox{
  text-align: center;
  /* padding: 20px 0; */
  margin-top: 20px;
}
.ageBox>li>div{
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/appoint/Appointment.vue